import { render, staticRenderFns } from "./BuscadorCard.vue?vue&type=template&id=fa8c6fe2&"
import script from "./BuscadorCard.vue?vue&type=script&lang=js&"
export * from "./BuscadorCard.vue?vue&type=script&lang=js&"
import style0 from "./BuscadorCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports